import { render, staticRenderFns } from "./MeasuresList.vue?vue&type=template&id=b9c646a6&scoped=true&"
import script from "./MeasuresList.vue?vue&type=script&lang=js&"
export * from "./MeasuresList.vue?vue&type=script&lang=js&"
import style0 from "./MeasuresList.vue?vue&type=style&index=0&id=b9c646a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c646a6",
  null
  
)

export default component.exports